/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type { ITransferFrom, ITransferFromInterface } from "../ITransferFrom";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export class ITransferFrom__factory {
  static readonly abi = _abi;
  static createInterface(): ITransferFromInterface {
    return new utils.Interface(_abi) as ITransferFromInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ITransferFrom {
    return new Contract(address, _abi, signerOrProvider) as ITransferFrom;
  }
}
